import * as Sentry from '@sentry/react'
import { emailHtmlToPlainText, sanitizeEmailHtml } from './emailHtml'

export type CopyRenderedEmailOutcome = 'copied' | 'clipboard-error'

export const useCopyRenderedEmail = () => {
  return async (subject: string, bodyHtml: string): Promise<CopyRenderedEmailOutcome> => {
    const safeHtml = sanitizeEmailHtml(bodyHtml)
    const plainText = `Subject: ${subject}\n\n${emailHtmlToPlainText(safeHtml)}`
    try {
      if (typeof ClipboardItem === 'undefined') {
        await navigator.clipboard.writeText(plainText)
      } else {
        await navigator.clipboard.write([
          new ClipboardItem({
            'text/html': new Blob([safeHtml], { type: 'text/html' }),
            'text/plain': new Blob([plainText], { type: 'text/plain' }),
          }),
        ])
      }
      return 'copied'
    } catch (error) {
      Sentry.captureException(error)
      return 'clipboard-error'
    }
  }
}
